import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Money as MoneyField, RequiredValidator } from '../../Components/Form';
import { ulid } from 'ulid';

const AddCashPayment = ({customer, addCashPayment, isOpen, setIsOpen}) => {
    return <Modal title="Add cash" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{customer, addCashPayment}} />}
    </Modal>
}

const Inner = ({customer, addCashPayment}) => {
    const data = {
        customerId: customer.id,
        paymentId: ulid(),
    }

    return <Form data={data} onSubmit={addCashPayment} closeModalOnSubmit>
        <MoneyField name="pence" label="Amount" validators={[RequiredValidator]} />
        <Actions submit={{label: 'Add'}} cancel />
    </Form>
}


export default AddCashPayment;
